import lu from '@/util/languageUtil'

const methods = {}

methods.createStatusHistoryItems = function (types, items, title) {
  const sortItems = [...items]
  // items.slice()

  sortItems.sort((a, b) => {
    const arrDataA = a.changeAt.split('-')
    const arrDataB = b.changeAt.split('-')

    const dateA = new Date(arrDataA[0], arrDataA[1], arrDataA[2], 0, 0, 0)
    const dateB = new Date(arrDataB[0], arrDataB[1], arrDataB[2], 0, 0, 0)

    if (dateA > dateB) return -1
    if (dateA < dateB) return 1
    return 0
  })

  // const isPropertyInType = items.length > 0 && 'type' in items[0]
  // if (!isPropertyInType) {
  //   return [
  //     {
  //       title: title,
  //       items: sortItems,
  //       itemKey: ''
  //     }
  //   ]
  // }

  return types.reduce((accumulator, currentValue, currentIndex, array) => {
    const sameTypeObjs = sortItems.filter((ele) => ele.type === currentValue.id)
    const type = currentValue.name
    accumulator.push({
      title: currentValue.name + lu.t('storage.storage_status-change-history'),
      items: sameTypeObjs,
      itemKey: '',
      type
    })

    return accumulator
  }, [])
}

export default { methods }
